export const submitFiltersScroll = (filtersWrapper: HTMLElement) => {
    const searchParams = window.location.search
    if (searchParams) {
        window.scrollTo({
            top: filtersWrapper.getBoundingClientRect().top + window.scrollY,
            behavior: 'smooth'
        })
    }
}
